import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBellOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBellOff"><Path d="M22.4141 21.0002L2.99991 1.58594L1.58569 3.00015L4.80799 6.22245C4.28213 7.16432 3.93461 8.22331 3.81319 9.35647L3 17.5H16.0855L20.9999 22.4144L22.4141 21.0002Z" fill="currentColor"/><Path d="M21 17.5H20.3285L6.73326 3.90474C8.16673 2.71141 10.0074 2 12 2C16.2077 2 19.7385 5.17264 20.1867 9.35648L21 17.5Z" fill="currentColor"/><Path d="M7.41601 19C8.18757 20.7659 9.94965 22 12 22C14.0503 22 15.8124 20.7659 16.5839 19H7.41601Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBellOff;
